import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';

export class CheckboxField extends Component {
  static propTypes = {
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    value: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    inputRef: PropTypes.func,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    inverted: PropTypes.bool,
  };

  static defaultProps = {
    label: null,
    type: "checkbox",
    value: false,
    inputRef: () => null,
    diabled: false,
    tooltip: null,
    inverted: false,
  };

  render() {
    const { id, type, name, label, onChange, inputRef, value, disabled, tooltip, inverted } = this.props;
    const hasLabel = !!label;
    const className = `input-field field-type-${type} ${
      hasLabel ? 'input-field-label' : 'input-field-no-label'
    }`;

    const lbl = (
      <label htmlFor={ !!id ? id : name }>
        { label }
      </label>
      )

    return (
      <div className={classNames(className, {'disabled': disabled, 'inverted': inverted})}>
        <input
          ref={inputRef}
          id={ !!id ? id : name }
          name={name}
          type={type}
          value={value}
          onChange={onChange}
          checked={value ? true : ''}
          disabled={disabled}
        />
        {
          tooltip ?
          <Tooltip title={ tooltip }>
            { lbl }
          </Tooltip>
          : <React.Fragment>{ lbl }</React.Fragment>
        }

      </div>
    );
  }
}

export default CheckboxField;
